<template>
  <div>
    <div class="content-form-calification">
      <div class="header d-flex justify-content-between">
        <div>
          Evaluación de riesgos <strong>SIN</strong> medidas de mitigación
        </div>
        <div
          class="d-flex text-kinney pr-3"
          style="cursor: pointer"
          @click.prevent="$bvModal.show('modal-kinney')"
        >
          M. Kinney
          <div class="ml-2">
            <img src="@/assets/images/icons/icon-matriz-iper/eye.png" alt="" />
          </div>
        </div>
      </div>
      <form class="mt-5" @submit.prevent="saveData">
        <div class="row mb-5">
          <div class="col-md-9">
            <div class="row">
              <b-col cols="12" class="mb-5">
                <Select
                  label="Determina la Probabilidad (P)"
                  name="name"
                  v-model="formData.probability"
                  :options="dataKinney?.probability"
                  :value="formData.probability"
                  :required="true"
                  :disabled="false"
                />
              </b-col>
              <b-col cols="12" class="mb-5">
                <Select
                  label="Determina la Frecuencia (F)"
                  name="frequency"
                  v-model="formData.frequency"
                  :options="dataKinney?.frequency"
                  :value="formData.frequency"
                  :required="true"
                  :disabled="false"
                />
              </b-col>
              <b-col cols="12" class="mb-5">
                <Select
                  label="Determina el Impacto (I)"
                  name="impact"
                  v-model="formData.impact"
                  :options="dataKinney?.impact"
                  :value="formData.impact"
                  :required="true"
                  :disabled="false"
                />
              </b-col>
              <b-col cols="12" class="">
                <Textarea
                  label="Descripción del riesgo"
                  name="risk_residual_description"
                  :rows="'3'"
                  :value="formData.risk_residual_description"
                  @input="
                    (event) => (formData.risk_residual_description = event.target.value)
                  "
                />
              </b-col>
            </div>
          </div>
          <div class="col-md-3">
            <div class="content-classification">
              <div class="content-classification-item">
                <div class="title-classification" :style="{
                      backgroundColor: riskClassification?.background,
                      color: riskClassification?.color
                    }">{{ riskClassification?.name }}</div>
                <div class="content-calification">
                  <span>{{ score }}</span>
                  <img
                    :src="riskClassification?.icon"
                    alt=""
                  />
                </div>
              </div>
              <div class="title-risk mt-3">Clasificación del Riesgo (R)</div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center mb-4">
          <button
            class="button_primary"
            type="submit"
            :disabled="isBusy || isDisabled"
          >
            <b-spinner v-if="isBusy" />
            Guardar cambios
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import useInputs from "@/components/general/Inputs";
const { Input, Textarea, Select } = useInputs();
export default {
  components: {
    Input,
    Textarea,
    Select,
  },
  props: {
    isBusy: {
      type: Boolean,
      default: false,
    },
    dataKinney: {
      type: Object,
      default: null,
    },
    riskClassification: {
      type: Object,
      default: null,
    },
    score: {
      type: Number,
      default: 0,
    },
    record: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      formData: {
        probability: null,
        risk_residual_description: "",
        frequency: null,
        impact: null,
      },
    };
  },
  watch: {
    record() {
      const me = this;
      if (me.record) me.loadData();
    }
  },
  computed: {
    isDisabled() {
      const me = this;
      const isDisabled =
        me.formData.probability === null ||
        me.formData.frequency === null ||
        me.formData.impact === null ||
        me.formData.risk_residual_description === ""
          ? true
          : false;
      return isDisabled;
    },
  },
  methods: {
    saveData() {
      const me = this;
      me.$emit("saveData", {
        without_mitigation: {
          risk_residual_description: me.formData.risk_residual_description,
          probability: me.formData.probability.id,
          frequency: me.formData.frequency?.id,
          impact: me.formData.impact?.id,
        }
      });
    },
    async loadData() {
      const me = this;
      me.formData.probability = null;
      me.formData.frequency = null;
      me.formData.impact = null;
      if (me.record?.without_mitigation?.probability) {
        const record = me.dataKinney?.probability.find(
          (item) => item.id === me.record?.without_mitigation?.probability
        )
        me.formData.probability = {
          id: record.id,
          name: record.name
        }
      }
      
      if (me.record?.without_mitigation?.frequency) {
        const record = me.dataKinney?.frequency.find(
          (item) => item.id === me.record?.without_mitigation?.frequency
        )
        me.formData.frequency = {
          id: record.id,
          name: record.name
        }
      }
      
      if (me.record?.without_mitigation?.impact) {
        const record = me.dataKinney?.impact.find(
          (item) => item.id === me.record?.without_mitigation?.impact
        )
        me.formData.impact = {
          id: record.id,
          name: record.name
        }
      }
      me.formData.risk_residual_description = me.record?.without_mitigation?.risk_residual_description || '';
    },
  },
  mounted() {
    const me = this;
    if (me.record) me.loadData();
  }
};
</script>

<style lang="css">
.content-form-calification {
  border: 1px solid #cfd8dc;
  padding: 12px;
  border-radius: 8px;
}
.content-form-calification .header {
  color: #37474f !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  text-align: left !important;
  line-height: 40px;
  background-color: #eceff1 !important;
  padding-left: 10px;
}
.content-form-calification .header strong {
  color: #0c9e42 !important;
}
.text-kinney {
  color: #5d5fef !important;
  font-size: 18px !important;
}
.content-classification {
  border: 1px solid #cfd8dc;
  padding: 8px;
  border-radius: 8px;
}
.content-classification .content-classification-item {
  border: 1px solid #eceff1;
  border-radius: 8px;
  padding: 8px;
}
.content-classification .title-risk {
  text-align: center;
  font-weight: 400;
  font-size: 12px;
  color: #78909c;
}
.content-classification .content-classification-item .title-classification {
  text-align: center;
  font-weight: 400;
  font-size: 12px;
  background-color: #eceff1;
  color: #263238;
  border-radius: 4px;
  padding: 4px;
}
.content-classification .content-classification-item .content-calification {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: 10px;
}
.content-classification
  .content-classification-item
  .content-calification
  span {
  color: #37474f !important;
  font-size: 20px !important;
  font-weight: 700 !important;
}
</style>
